import type { BasicObject } from '../../uiObjects/basicObject';

import { GRID_ADD_MODE, isDraggableGridShapeType } from './addMoveMode';
import type { GridAddMoveMode } from './addMoveMode';
import { getGridDragModeButton } from './dragModeButton';
import type { GridDragModeButton } from './dragModeButton';

interface GridDragModeButtonGetter {
  actingAsNumberLineGetter?: boolean;
  gridAddMoveMode: GridAddMoveMode;
  setGridAddMoveMode: (mode: GridAddMoveMode) => void;
  m?: string;
  g?: {
    currentObj?: {
      second?: unknown;
      t?: string;
    };
    selected?: boolean;
  };
  st?: string;
  grabFocus: () => void;
}

interface AddGridDragModeButtonToRowOptions {
  row: BasicObject;
  getter: GridDragModeButtonGetter;
  $canvas: JQuery<HTMLElement>;
  getThemeColor: () => string;
  hasMovableGridContent: () => boolean;
  onIncompleteShapeDragAttempt?: (shapeType: string) => void;
  width?: number;
  height?: number;
}

const getIncompleteShapeType = (
  getter: GridDragModeButtonGetter
): string | undefined => {
  const currentObj = getter.g?.currentObj;

  if (!currentObj || currentObj.second) {
    return undefined;
  }

  const shapeType = currentObj.t || getter.m;

  return isDraggableGridShapeType(shapeType) ? shapeType : undefined;
};

export const addGridDragModeButtonToRow = ({
  row,
  getter,
  $canvas,
  getThemeColor,
  hasMovableGridContent,
  onIncompleteShapeDragAttempt,
  width = 30,
  height = 30,
}: AddGridDragModeButtonToRowOptions): GridDragModeButton | undefined => {
  if (getter.actingAsNumberLineGetter) {
    return undefined;
  }

  const dragModeButton = getGridDragModeButton({
    $canvas,
    width,
    height,
    getThemeColor,
    getMode: function () {
      return getter.gridAddMoveMode;
    },
    setMode: function (mode) {
      getter.setGridAddMoveMode(mode);
    },
    isSelected: function () {
      return Boolean(getter.g && getter.g.selected);
    },
    isCorrect: function () {
      return getter.st === 'c';
    },
    isDisabled: function () {
      return (
        getter.gridAddMoveMode === GRID_ADD_MODE &&
        (Boolean(getIncompleteShapeType(getter)) || !hasMovableGridContent())
      );
    },
    consumeDisabledClick: function () {
      const incompleteShapeType = getIncompleteShapeType(getter);

      if (incompleteShapeType) {
        onIncompleteShapeDragAttempt?.(incompleteShapeType);
      }

      return true;
    },
    onGrabFocus: function () {
      getter.grabFocus();
    },
  });

  row.add(dragModeButton);

  return dragModeButton;
};
